import styled from 'styled-components';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Typography from '../../../atoms/Typography';

export const Preview = styled.img`
  background-color: ${({ theme }) => theme.lightGray};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  /* transition: all .2s ease-in-out; */
  /* background-image: url(${({ image }) => image};); */
  /* background-size: cover; */
  object-fit: cover;
  /* border-radius: 5px; */
  transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: inherit;
  width: 100%;
  ${({ uploading }) => uploading && `filter: opacity(25%);`}

  ${({ onClick, theme }) =>
    onClick &&
    `
  &:hover {
    cursor: pointer;
    border-color: ${theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    // border-color: red;

  }
`} /* margin: 0.5rem; */
`;

export const IconContainer = styled.div`
  position: absolute;
  ${({ preview }) =>
    preview === 'circle'
      ? `
      left: 1.3rem;
    top: 0.9rem;
        `
      : `
      right: 5px;
    top: 5px;
        `};

  z-index: 1;
  // color: ${({ theme }) => theme.secondaryColor[150]};

  svg {
    background-color: ${({ theme }) => theme.secondaryColor[150]};
    border-radius: 50%;
    // border: 1px solid ${({ theme }) => theme.grey[300]};
    padding: 2px;
    width: 1.5rem;
    height: 1.5rem;
  }

  ${({ onClick, theme }) =>
    onClick &&
    `
    &:hover {
    cursor: pointer;
    border-color: ${theme.grey[400]};
    }
  `}
`;

export const UploaderContainer = styled.div`
  display: flex;
  margin: 0.5rem;
  margin-top: 1rem;
  position: relative;
  border-radius: 4px;
  margin-bottom: 75px;
  && {
    border: ${({ border }) => border};
  }
  ${({ preview }) => {
    if (preview === 'circle') {
      return `
    width: 12rem;
    height: 12rem;
    border-radius: 50%;
        `;
    }
    if (preview === 'cover') {
      return `
    width: 42.1875rem;
    height: 15.625rem;
`;
    }
    return `
    width: 10rem;
    height: 10rem;
        `;
  }}
`;

export const Label = styled(Typography)`
  && {
    margin-left: 0.5rem;
  }
`;

export const Container = styled.div`
  margin-top: 1rem;
  // margin-bottom: 2rem;
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Uploader = styled.div`
  background-color: ${({ theme }) => theme.secondaryColor[50]};
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 8px;
  text-align: center;
  font-size: 0.8rem;
  ${({ disabled, theme }) =>
    disabled
      ? `
  cursor: not-allowed;
  
  `
      : `
    &:hover {
    cursor: pointer;
    border-color: ${theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  
  `}/* &:hover {
    cursor: pointer;
    border-color: ${({ theme }) => theme.grey[700]};
    transition: 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  } */
`;

export const UploadIcon = styled(CloudUploadIcon)`
  && {
    font-size: 50px;
    color: ${({ theme }) => theme.secondaryColor[150]};
    margin-bottom: 0.3rem;
  }
`;

export const LoadingIcon = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  p {
    margin-top: 1rem;
  }
`;

export const StyledLabel = styled.div`
  position: absolute;
  background-color: #ffffff;
  color: ${({ theme }) => theme.common.inBlack};
   && {
    top: ${({ top }) => top};
    left: ${({ left }) => left};
    bottom: ${({ bottom }) => bottom};
  }
  text-transform: none !Important;
`;
